export default "/images/fe14372b216790ce5564b76e2a0e1225.avif";